import { EuiSpacer } from '@elastic/eui';
import AudioTable from 'components/Web_User_Interface/720p_Series/Multimedia/Audio/audioTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  AudioTable,
  BreadCrumbs,
  SEOHelmet,
  React
};